function reviewsSliderInit() {
	const reviewsSliders = document.querySelectorAll(
		'.wp-block-cancan-reviews-slider'
	);

	if (!reviewsSliders.length) return;

	const swipers = []; // store instances

	const initSwiper = (reviewsSlider) => {
		const swiperEl = reviewsSlider.querySelector('.swiper');
		if (!swiperEl || swiperEl.swiper) return;

		const instance = new Swiper(swiperEl, {
			slidesPerView: 1,
			loop: true,
			allowTouchMove: true,
			spaceBetween: 20,

			autoplay: {
				delay: 3500,
				disableOnInteraction: true,
				pauseOnMouseEnter: true,
			},

			navigation: {
				nextEl: reviewsSlider.querySelector('.swiper-button-next'),
				prevEl: reviewsSlider.querySelector('.swiper-button-prev'),
				disabledClass: 'disabled',
			},

			autoHeight: true,
		});

		swipers.push(instance);
	};

	// Lazy init using IntersectionObserver
	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;

				initSwiper(entry.target);
				obs.unobserve(entry.target);
			});
		},
		{
			root: null,
			rootMargin: '0px 0px -20% 0px',
			threshold: 0.1,
		}
	);

	reviewsSliders.forEach((slider) => observer.observe(slider));
}

document.addEventListener('DOMContentLoaded', reviewsSliderInit);
